document.addEventListener("DOMContentLoaded", function () {
  new Swiper(".instructor-swiper", {
    slidesPerView: 1,
    spaceBetween: 15,
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    breakpoints: {
      576: {
        slidesPerView: 1.2
      },
      768: {
        slidesPerView: 2
      },
      992: {
        slidesPerView: 2.5
      }
    }
  });
});
